import debounce from 'lodash/debounce';
import toggleClasses from './classes-toggle';

const getImageList = () => {
  const allImages = document.querySelectorAll('img.image');
  return allImages;
};

const originalImages = Array.from(getImageList()).map(img => Array.from(img.classList));

const changeableImages = getImageList();

const handleImageClasses = debounce(() => {
  const windowWidth = window.innerWidth;

  const mobileColorPrefix = 'u--mobileBorder-';
  const tabletColorPrefix = 'u--tabletBorder-';
  const desktopColorPrefix = 'u--border-';

  const mobileBorderPrefix = 'mobile-image-';
  const tabletBorderPrefix = 'tablet-image-';
  const desktopBorderPrefix = 'desktop-image-';

  changeableImages.forEach((image, index) => {
    image.className = ''; // eslint-disable-line no-param-reassign
    image.className = originalImages[index].join(' '); // eslint-disable-line no-param-reassign

    if (windowWidth < 760) {
      if (image.className.includes(mobileColorPrefix || mobileBorderPrefix)) {
        toggleClasses(
          [tabletColorPrefix, desktopColorPrefix, tabletBorderPrefix, desktopBorderPrefix],
          image,
        );
      }
      if (!image.className.includes(mobileColorPrefix || mobileBorderPrefix)) {
        toggleClasses([desktopColorPrefix, desktopBorderPrefix], image);
      }
    }

    if (windowWidth >= 760 && windowWidth < 1024) {
      if (image.className.includes(tabletColorPrefix || tabletBorderPrefix)) {
        toggleClasses(
          [mobileColorPrefix, desktopColorPrefix, mobileBorderPrefix, desktopBorderPrefix],
          image,
        );
      }
    }

    if (windowWidth >= 1024) {
      toggleClasses(
        [mobileColorPrefix, tabletColorPrefix, mobileBorderPrefix, tabletBorderPrefix],
        image,
      );
    }
  });
}, 250);

if (changeableImages.length !== 0) {
  window.addEventListener('DOMContentLoaded', handleImageClasses, false);
  window.addEventListener('resize', handleImageClasses, false);
}
